import React, { useState } from "react";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import colors from "../Constants/colors";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";

const DatasetTypeInfo = () => {
  const [currentCard, setCurrentCard] = useState(0);

  // Data for each card
  const cards = [
    {
      title: "Structured Data",
      description:
        "Structured data is well-organized, like CSV or XLS files. Typically used for tables with defined rows and columns.",
      example: (
        <table
          style={{
            borderCollapse: "collapse",
            margin: "20px 0",
            width: "100%",
            border: `1px solid ${colors.extremeWhite}`,
            borderRadius: 4,
          }}
        >
          <thead>
            <tr
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = colors.primaryBlue)
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = colors.primaryBlue)
              }
            >
              <th
                style={{
                  backgroundColor: colors.primaryBlue,
                  color: "white",
                  padding: "10px",
                  textAlign: "left",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                Name
              </th>
              <th
                style={{
                  backgroundColor: colors.primaryBlue,
                  color: "white",
                  padding: "10px",
                  textAlign: "left",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                Age
              </th>
              <th
                style={{
                  backgroundColor: colors.primaryBlue,
                  color: "white",
                  padding: "10px",
                  textAlign: "left",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                Department
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{ backgroundColor: "#333", color: "#fff" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#333")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#333")
              }
            >
              <td
                style={{
                  padding: "10px",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                John Doe
              </td>
              <td
                style={{
                  padding: "10px",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                30
              </td>
              <td
                style={{
                  padding: "10px",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                Engineering
              </td>
            </tr>
            <tr
              style={{ backgroundColor: "#333", color: "#fff" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#333")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#333")
              }
            >
              <td
                style={{
                  padding: "10px",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                Jane Doe
              </td>
              <td
                style={{
                  padding: "10px",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                25
              </td>
              <td
                style={{
                  padding: "10px",
                  border: `1px solid ${colors.extremeWhite}`,
                }}
              >
                Marketing
              </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      title: "Unstructured Data",
      description:
        "Unstructured data includes documents like PDFs, TXT, and DOC files with free-form text and no predefined structure.",
      example: (
        <Typography variant="body2">
          “This document contains research about AI models and their
          applications in various fields.”
        </Typography>
      ),
    },
    {
      title: "Unstructured with Metadata",
      description:
        "Unstructured data enhanced with metadata like tags or fields, helping categorize and filter documents.",
      example: (
        <Typography variant="body2">
          Document: "Project on LLM development." <br />
          Metadata: {'{ field: "LLM development", category: "Technology" }'}
        </Typography>
      ),
    },
  ];

  // Function to go to the next card
  const handleNext = () => {
    setCurrentCard((prevCard) => (prevCard + 1) % cards.length);
  };

  // Function to go to the previous card
  const handlePrev = () => {
    setCurrentCard((prevCard) => (prevCard - 1 + cards.length) % cards.length);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      {/* Introduction */}
      <Box mb={2}>
        <Typography variant="h6" gutterBottom>
          Upload Retrieval Dataset
        </Typography>
        <Typography variant="body2" gutterBottom>
          You can upload different types of datasets by either uploading files
          or entire folders. Here's a quick guide to help you choose the right
          dataset type:
        </Typography>
        <Typography variant="body2">
          For more details, check out the{" "}
          <a
            href="https://docs.queryloop.ai/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", textDecoration: "underline" }}
          >
            documentation.
          </a>
        </Typography>
      </Box>

      {/* Card Display */}
      <Card sx={{ width: "100%", maxWidth: 400 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {cards[currentCard].title}
          </Typography>
          <Typography variant="body2" gutterBottom>
            {cards[currentCard].description}
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>Example:</strong>
          </Typography>
          {cards[currentCard].example}
        </CardContent>
      </Card>

      {/* Navigation Buttons */}
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        maxWidth={400}
        mt={2}
      >
        <Button
          variant="contained"
          sx={{ color: colors.extremeWhite }}
          onClick={handlePrev}
          disabled={currentCard === 0}
        >
          <ArrowLeft />
        </Button>
        <Typography variant="body2" display="flex" alignItems="center">
          {currentCard + 1} / {cards.length}{" "}
          {/* Display the current card number */}
        </Typography>
        <Button
          variant="contained"
          sx={{ color: colors.extremeWhite }}
          onClick={handleNext}
          disabled={currentCard === cards.length - 1}
        >
          <ArrowRight />
        </Button>
      </Box>
    </Box>
  );
};

export default DatasetTypeInfo;
